/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetReservationCreditPurchasePathParameters } from 'api/actions/get-reservation-credit-purchase/get-reservation-credit-purchase-path-parameters';
import { GetReservationCreditPurchaseResponse } from 'api/actions/get-reservation-credit-purchase/get-reservation-credit-purchase-response';

type GetReservationCreditPurchaseQueryParameters = Record<string, any>;

/**
 * The path of the GetReservationCreditPurchase action.
 */
export const getReservationCreditPurchaseActionPath = new SweetPath<keyof GetReservationCreditPurchasePathParameters>(
  '/reservations/credits/purchases/{purchaseId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetReservationCreditPurchase actions.
 */
export default function createGetReservationCreditPurchaseAction(axios: AxiosInstance) {
  return function getReservationCreditPurchaseAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetReservationCreditPurchasePathParameters;
    query?: GetReservationCreditPurchaseQueryParameters;
  }) {
    const path = getReservationCreditPurchaseActionPath.insert(parameters);

    return axios.get<GetReservationCreditPurchaseResponse, GetReservationCreditPurchaseResponse>(path, {
      params: query,
      headers,
    });
  };
}
